export default {"src":"/_next/static/media/trustpilot-logo-white-text.5c8e665d.svg","height":28,"width":115,"blurWidth":0,"blurHeight":0};